<template>
<div>
    <accounting-books-receipt-form :subsidiaryLedgerId="subsidiaryLedgerId" ref="accountingBooksReceiptFormModal"></accounting-books-receipt-form>
    <div class="custom-search">
        <b-row>
            <b-col class="col-md-2 mb-1">
                <label for="accounting-number-input">{{ $t('accountingTransactionLedgerReport.accounting_no') }}</label>
                <b-form-input size="sm" v-model="accountingNumber" :placeholder="$t('accountingTransactionLedgerReport.accounting_no')" type="text" class="d-inline-block" v-on:keyup.enter="getAccountingTransactionLedgerReportList()"/>
            </b-col>
            <b-col class="col-md-2 mb-1">
                <label for="accounting-name-input">{{ $t('accountingTransactionLedgerReport.accounting_name') }}</label>
                <b-form-input size="sm" v-model="accountingName" :placeholder="$t('accountingTransactionLedgerReport.accounting_name')" type="text" class="d-inline-block" v-on:keyup.enter="getAccountingTransactionLedgerReportList()"/>
            </b-col>
            <b-col class="col-md-2 mb-1">
                <label for="start-date-input">{{ $t('accountingTransactionLedgerReport.start_date') }}</label>
                <CustomDatePicker :datePickerValidateOption="0" v-model="startDate" @input="getAccountingTransactionLedgerReportList()"></CustomDatePicker>
            </b-col>
            <b-col class="col-md-2 mb-1">
                <label for="end-date-input">{{ $t('accountingTransactionLedgerReport.end_date') }}</label>
                <CustomDatePicker :datePickerValidateOption="0" v-model="endDate" @input="getAccountingTransactionLedgerReportList()"></CustomDatePicker>
            </b-col>
            <b-col class="col-md-4 custom-search d-flex justify-content-end">
                <div class="d-flex align-items-center">
                    <b-button class="d-inline-block mr-05" size="sm" variant="outline-primary" @click="getAccountingTransactionLedgerReportList()">{{ $t('others.list') }}</b-button>
                    <b-dropdown style="width: 7em; height: 2.3em; border-color:#6B7280; color:#374151;" id="dropdown-grouped" variant="outline-secondary" right size="sm" :text="$t('others.download')">
                        <b-dropdown-item @click="exportExcel()">
                            <span>{{ $t('excel.excel') }}</span>
                        </b-dropdown-item>
                        <b-dropdown-item @click="exportCsv(0)">
                            <span>{{ $t('excel.csv') }}</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </b-col>
        </b-row>
    </div>
    <!-- table -->
    <vue-good-table ref="accountingTransactionLedgerReportList" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
                      enabled: false,
                      externalQuery: searchTerm }" :select-options="{
                      enabled: false,
                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                      selectionInfoClass: 'custom-class',
                      selectionText: 'rows selected',
                      clearSelectionText: 'clear',
                      disableSelectInfo: true, // disable the select info panel on top
                      selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                    }" :pagination-options="{
                      enabled: true,
                      perPage:pageLength
                    }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field ==='accountingTransactionDocumentDate'" class="text-nowrap">
                {{ $t('accountingTransactionLedgerReport.document_date') }}
            </span>
            <span v-else-if="props.column.field === 'accountingTransactionType'" class="text-nowrap">
                {{ $t('accountingTransactionLedgerReport.type') }}
            </span>
            <span v-else-if="props.column.field === 'accountingNumber'" class="text-nowrap">
                {{ $t('accountingTransactionLedgerReport.accounting_no') }}
            </span>
            <span v-else-if="props.column.field === 'accountingName'" class="text-nowrap">
                {{ $t('accountingTransactionLedgerReport.accounting_name') }}
            </span>
            <span v-else-if="props.column.field === 'documentNo'" class="text-nowrap">
                {{ $t('accountingTransactionLedgerReport.document_no') }}
            </span>
            <span v-else-if="props.column.field === 'accountingTransactionDescription'" class="text-nowrap">
                {{ $t('accountingTransactionLedgerReport.description') }}
            </span>
            <span v-else-if="props.column.field === 'currency'" class="text-nowrap">
                {{ $t('accountingTransactionLedgerReport.currency') }}
            </span>
            <span v-else-if="props.column.field === 'debtAmount'" class="text-nowrap">
                {{ $t('accountingTransactionLedgerReport.debt_amount') }}
            </span>
            <span v-else-if="props.column.field === 'creditAmount'" class="text-nowrap">
                {{ $t('accountingTransactionLedgerReport.credit_amount') }}
            </span>
            <span v-else-if="props.column.field === 'balance'" class="text-nowrap">
                {{ $t('accountingTransactionLedgerReport.balance') }}
            </span>
            <span v-else-if="props.column.field === 'balanceType'" class="text-nowrap">
                {{ $t('accountingTransactionLedgerReport.balance_type') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <span>
                    <b-button v-if="props.row.accountingTransactionId > 0" v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.accountingTransactionId)">
                        <feather-icon icon="EditIcon" />
                    </b-button>
                </span>
            </span>
        </template>
        <!-- pagination -->
        <template
          slot="pagination-bottom"
          slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }} </span>
            <b-form-select
                v-model="pageLength"
                :options="['10','25','50','100']"
                class="mx-1"
                @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
          </div>
          <div>
            <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            total: 0,
            pageLength: 50,
            searchTerm: '',
            dir: false,
            pageNo: 1,
            name: '',
            startDate: null,
            endDate: null,
            rows: [],
            columns: [
                {
                    label: this.$t('accountingTransactionLedgerReport.document_date'),
                    field: `accountingTransactionDocumentDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('accountingTransactionLedgerReport.type'),
                    field: `accountingTransactionType`,
                },
                {
                    label: this.$t('accountingTransactionLedgerReport.accounting_no'),
                    field: `accountingNumber`,
                },    
                {
                    label: this.$t('accountingTransactionLedgerReport.accounting_name'),
                    field: `accountingName`,
                },
                {
                    label: this.$t('accountingTransactionLedgerReport.document_no'),
                    field: `documentNo`
                },
                {
                    label: this.$t('accountingTransactionLedgerReport.description'),
                    field: `accountingTransactionDescription`,
                },
                {
                    label: this.$t('accountingTransactionLedgerReport.currency'),
                    field: `currency`,
                },
                {
                    label: this.$t('accountingTransactionLedgerReport.debt_amount'),
                    field: `debtAmount`,
                    formatFn: this.$formatAmount,
                    tdClass: 'text-right',
                    thClass: 'text-right'
                },
                {
                    label: this.$t('accountingTransactionLedgerReport.credit_amount'),
                    field: `creditAmount`,
                    formatFn: this.$formatAmount,
                    tdClass: 'text-right',
                    thClass: 'text-right'
                },
                {
                    label: this.$t('accountingTransactionLedgerReport.balance'),
                    field: `balance`,
                    formatFn: this.$formatAmount,
                    tdClass: 'text-right',
                    thClass: 'text-right'
                },
                                {
                    label: this.$t('accountingTransactionLedgerReport.debt_amount_cv'),
                    field: `debtAmountCv`,
                    formatFn: this.$formatAmount,
                    tdClass: 'text-right',
                    thClass: 'text-right'
                },
                {
                    label: this.$t('accountingTransactionLedgerReport.credit_amount_cv'),
                    field: `creditAmountCv`,
                    formatFn: this.$formatAmount,
                    tdClass: 'text-right',
                    thClass: 'text-right'
                },
                {
                    label: this.$t('accountingTransactionLedgerReport.balance_cv'),
                    field: `balanceCv`,
                    formatFn: this.$formatAmount,
                    tdClass: 'text-right',
                    thClass: 'text-right'
                },
                {
                    label: this.$t('accountingTransactionLedgerReport.balance_type'),
                    field: `balanceType`
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em'
                },
            ],
            accountingNumber: '',
            accountingName : '',
            searchDebounce: null,
        }

    },
    props: {
        subsidiaryLedgerId: {
            type: Number
        }
    },
    watch: {
        accountingNumber() {
            this.debouncedSearch()
        },
        accountingName() {
            this.debouncedSearch()
        }
    },
    mounted() {
        this.startDate = new Date().toJSON()
        this.endDate = new Date().toJSON()
    },
    methods: {
        debouncedSearch() {
            clearTimeout(this.searchDebounce)
            this.searchDebounce = setTimeout(() => {
                if (this.pageNo !== undefined) this.pageNo = 1
                this.getAccountingTransactionLedgerReportList()
            }, 300)
        },
        getAccountingTransactionLedgerReportList() {
            this.rows = []
            const controller = {
                name: 'AccountingTransaction',
                actionName: 'AccountingTransactionLedgerReport'
            }
            const data = {
                pageLength: this.pageLength,
                pageNo: this.pageNo,
                startDate: this.startDate,
                endDate: this.endDate,
                subsidiaryLedgerId: this.subsidiaryLedgerId,
                accountingNumber: this.accountingNumber,
                accountingName : this.accountingName
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.total = response.data.total
                    response.data.accountingTransactionLedgerReportList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })

        },
        async getInfo(id) {
            this.$refs.accountingBooksReceiptFormModal.showInfo(id)
        },
        exportExcel() {
            const controller = {
                name: 'AccountingTransaction',
                actionName: 'CanExport'
            }
            const data = {
                columnList: this.columns,
                DataList: this.rows
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Muavin Raporu", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        exportCsv() {
            const controller = {
                name: 'AccountingTransaction',
                actionName: 'CanExportCsv'
            }
            const data = {
                columnList: this.columns,
                DataList: this.rows
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Muavin Raporu", response.data.base64, 'csv')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }        
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
